/** Tag chips stored as CSV. Mode is config_form.format: empty/`number` = integers, `text` = strings. */

const INTEGER = /^\d+$/;

export type ChipsFormat = string | undefined | null;

export function isChipsWidget(schema: { widget?: { id?: string } | string } | undefined): boolean {
  const w: any = (schema as any)?.widget;
  return w === 'chips' || w?.id === 'chips';
}

export function isTextChipsFormat(format: ChipsFormat): boolean {
  return `${format ?? ''}`.trim().toLowerCase() === 'text';
}

export function normalizeChip(raw: unknown, format?: ChipsFormat): string | null {
  const text = `${raw ?? ''}`.trim();
  if (!text) {
    return null;
  }
  if (isTextChipsFormat(format)) {
    if (text.includes(',')) {
      return null;
    }
    return text;
  }
  if (!INTEGER.test(text)) {
    return null;
  }
  return String(Number(text));
}

export function parseChipsValue(raw: unknown, format?: ChipsFormat): string[] {
  if (raw == null || raw === '') {
    return [];
  }
  const parts = Array.isArray(raw) ? raw : `${raw}`.split(',');
  const chips: string[] = [];
  for (const part of parts) {
    const chip = normalizeChip(part, format);
    if (chip != null && !chips.includes(chip)) {
      chips.push(chip);
    }
  }
  return chips;
}

export function serializeChips(chips: string[]): string {
  return chips.join(',');
}

export function addChip(chips: string[], raw: unknown, format?: ChipsFormat): string[] | null {
  const chip = normalizeChip(raw, format);
  if (chip == null || chips.includes(chip)) {
    return null;
  }
  return [...chips, chip];
}

export function removeChip(chips: string[], chip: string): string[] {
  return chips.filter((c) => c !== chip);
}
